/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "@krea/customer-features/shared-components/button";
import { useLoanApplicationFormStore } from "@krea/customer-features/store/loan-application-form/hooks";
import { useModalStore } from "@krea/customer-features/store/modal/hooks";
import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useController, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { useShallow } from "zustand/react/shallow";

import AllowedCustomerApplicationFlow from "@/components/application-form/fields/allowed-customer-application-flow";

import { RemoteIdentificationModalSMS } from "..";
import styles from "../sms/RemoteIdentificationModalSMS.module.scss";

const IdentifyCustomer = () => {
  const { t } = useTranslation();

  const closeModal = useModalStore(
    ({ closeModal }: { closeModal: () => void }) => closeModal,
  );

  const { remoteIdentification, formErrors, setRemoteIdentification } =
    useLoanApplicationFormStore(
      useShallow((state) => ({
        remoteIdentification: state.remoteIdentification,
        formErrors: state.formErrors,
        setRemoteIdentification: state.setRemoteIdentification,
      })),
    );

  const onCloseButtonClick = () => {
    closeModal();
  };

  const validationSchema = Yup.object().shape({
    isCustomerApplicationFlowAllowed: Yup.boolean().required(
      t("bankIDFlow.errorMessages.required")!,
    ),
  });

  const { control } = useForm({
    mode: "onChange",
    defaultValues: {
      isCustomerApplicationFlowAllowed:
        remoteIdentification.isCustomerApplicationFlowAllowed,
    },
    resolver: yupResolver(validationSchema),
  });

  const isCustomerApplicationFlowAllowedController = useController({
    name: "isCustomerApplicationFlowAllowed",
    control,
  });

  const onIsCustomerApplicationFlowAllowedChange = (value: boolean) => {
    isCustomerApplicationFlowAllowedController.field.onChange(value);
    setRemoteIdentification({
      ...remoteIdentification,
      isCustomerApplicationFlowAllowed: value,
    });
  };

  const openModal = useModalStore(({ openModal }) => openModal);

  const openSMSBankIdModal = () => {
    openModal({
      modal: <RemoteIdentificationModalSMS />,
      closeOnBackgroundClick: false,
    });
  };

  useEffect(() => {
    // Set errors from "outside" (async errors etc).
    if (!isEmpty(formErrors)) {
      onCloseButtonClick();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formErrors]);

  return (
    <>
      <div className={styles.topBanner}>
        <div className={styles.topBannerItem}>
          <h2 className={"tw-text-sm tw-font-black"}>
            {t("applicationForm.identificationHeading")}
          </h2>
          <Button
            onClick={onCloseButtonClick}
            variant="text"
            style={{ minHeight: 0 }}
          >
            {t("bankIDFlow.back")}
          </Button>
        </div>

        <hr className="mx-n6" />
      </div>
      <div className="tw-p-4">
        <AllowedCustomerApplicationFlow
          value={isCustomerApplicationFlowAllowedController.field.value}
          handleChange={({ value }: { name: string; value: boolean }) =>
            onIsCustomerApplicationFlowAllowedChange(value)
          }
        />
      </div>

      <div className="tw-flex tw-justify-center tw-p-6">
        <Button
          block
          justify="center"
          id="continue-button"
          onClick={openSMSBankIdModal}
        >
          {t("bankIDFlow.continue")}
        </Button>
      </div>
    </>
  );
};

export { IdentifyCustomer };
